import {
  ButtonFlavor,
  ButtonSize,
  ButtonType,
  DialogHeaderContent,
  DialogVariant,
  ExButton,
  ExDialog,
} from '@boomi/exosphere';
import { useTranslation } from 'react-i18next';
import './ModelConfigBlockDeleteDialog.scss';

interface ModelConfigBlockDeleteDialogProps {
  open: boolean;
  agentCount: number;
  onClose: () => void;
}

function ModelConfigBlockDeleteDialog({
  open,
  agentCount,
  onClose,
}: ModelConfigBlockDeleteDialogProps) {
  const [t] = useTranslation('common');

  const handleCancel = () => {
    onClose();
    document.body.style.overflow = 'unset';
  };

  const plural = agentCount === 1 ? '' : 's';
  const dialogDescription = t('models_blockdelete_description', {
    count: agentCount,
    plural,
  });

  return (
    <ExDialog
      dialogTitle={t('models_blockdelete_dialog_title')}
      open={open}
      hideClose={false}
      staticBackdrop
      variant={DialogVariant.SPACED}
      onCancel={handleCancel}
      headerContent={DialogHeaderContent.NEGATIVE}
    >
      <div className="block-delete-dialog-container">
        <div>{dialogDescription}</div>
      </div>
      <ExButton
        type={ButtonType.SECONDARY}
        data-testid="model-config-block-delete-close-button"
        size={ButtonSize.DEFAULT}
        flavor={ButtonFlavor.BRANDED}
        onClick={handleCancel}
        slot="footer"
      >
        {t('close')}
      </ExButton>
    </ExDialog>
  );
}

export default ModelConfigBlockDeleteDialog;
